/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PublishStatusVisitorAuth({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#PublishStatusVisitorAuth_svg__a)"><rect width={14} height={12} x={1} y={2} rx={2} /><rect width={6.438} height={4.402} x={4.781} y={7.212} rx={1} /><path d="M6.352 7.07V5.388a1 1 0 0 1 1-1H8.77c.485 0 .878.392.878.877v1.632M8 9.795V9.03" /></g><defs><clipPath id="PublishStatusVisitorAuth_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;